import { StreamingPlayerImage, StreamingPlayerTypography } from '@heardis/stream-contracts';
import CloseIcon from '../../../elements/icons/CloseIcon';
import DescriptionIcon from '../../../elements/icons/DescriptionIcon';
import ListIcon from '../../../elements/icons/ListIcon';
import { SidePanelTab } from '../Templates/three-rows-page-layout.types';
import { classNames } from '../../../utils/styles';
import Description from './Description/Description';
import classes from './SidePanel.module.css';
import Tracklist from './Tracklist/Tracklist';
import { BackgroundImage } from '../../Image';

type SidePanelProps = {
  descriptionEnabled: boolean;
  notesEnabled: boolean;
  spotifyEnabled: boolean;
  tracklistEnabled: boolean;
  description: {
    content: string;
    typography: StreamingPlayerTypography;
  };
  backgroundColor: string;
  backgroundImage: StreamingPlayerImage;
  typography: StreamingPlayerTypography;
  sidePanelStatus: { tab: SidePanelTab; isActive: boolean };
  handleSidePanelsActiveStatus: () => void;
  showTab: (tab: SidePanelTab) => void;
};

function SidePanel({ descriptionEnabled, notesEnabled, spotifyEnabled, tracklistEnabled, description, backgroundColor, backgroundImage, sidePanelStatus, handleSidePanelsActiveStatus, showTab, typography }: SidePanelProps): JSX.Element {
  const { fontFamily, fontWeight, fontSize, color } = typography;

  return (
    <div
      className={classNames(classes.sidePanel, sidePanelStatus.isActive ? classes.active : '')}
    >
      <div className={classes.sidePanelInnerWrapper} style={{ backgroundColor, fontFamily, fontWeight, fontSize, color }}>
        <div className={classes.actionLabelWrapper}>
          <button type="button" className={classes.actionLabel} onClick={handleSidePanelsActiveStatus} style={{ backgroundColor }}>
            {sidePanelStatus.isActive ? 'Hide' : 'Info'}
          </button>
        </div>
        <div className={classes.titleNavigationWrapper}>
          {descriptionEnabled && sidePanelStatus.tab === SidePanelTab.DESCRIPTION && <h2 className={classes.title}>Description</h2>}
          {tracklistEnabled && sidePanelStatus.tab === SidePanelTab.TRACKLIST && <h2 className={classes.title}>Tracklist</h2>}
          <nav className={classes.navigation}>
            {descriptionEnabled && tracklistEnabled && (
            <>
              <button
                type="button"
                className={classNames(classes.navigationItem, sidePanelStatus.tab === SidePanelTab.DESCRIPTION ? classes.active : '')}
                onClick={() => showTab(SidePanelTab.DESCRIPTION)}
              >
                <DescriptionIcon />
              </button>
              <button
                type="button"
                className={classNames(classes.navigationItem, sidePanelStatus.tab === SidePanelTab.TRACKLIST ? classes.active : '')}
                onClick={() => showTab(SidePanelTab.TRACKLIST)}
              >
                <ListIcon />
              </button>
            </>
            )}
            <button type="button" className={classNames(classes.navigationItem, classes.active, classes.closeIcon)} onClick={handleSidePanelsActiveStatus}>
              <CloseIcon />
            </button>
          </nav>
        </div>
        <section className={classes.content}>
          {descriptionEnabled && sidePanelStatus.tab === SidePanelTab.DESCRIPTION && <Description content={description.content} typography={description.typography} />}
          {tracklistEnabled && sidePanelStatus.tab === SidePanelTab.TRACKLIST && <Tracklist notesEnabled={notesEnabled} spotifyEnabled={spotifyEnabled} enableExpandAll />}
        </section>
        {backgroundImage.url && (
        <BackgroundImage
          url={backgroundImage.url}
          alt={backgroundImage.alt}
          blur={backgroundImage.blur}
          position={backgroundImage.position}
          fit={backgroundImage.fit}
          zIndex={-5}
        />
        )}
      </div>
    </div>
  );
}

export default SidePanel;
